import React, { useState, useEffect, useRef } from "react";
import { HexColorPicker } from "react-colorful";
import FormatColorFillIcon from "@mui/icons-material/FormatColorFill";
import { useCard } from "context/CardContext";

const BackgroundColorPicker = ({
  backgroundColor,
  setBackgroundColor,
  showPicker,
  setShowPicker,
}) => {
  const { getPickerPosition } = useCard();
  const pickerRef = useRef(null);
  const [position, setPosition] = useState({ top: 40, left: 0 });

  // Function to adjust position dynamically
  const updatePosition = () => {
    setPosition(
      getPickerPosition(pickerRef, "tool-icon-text-background-color")
    );
  };

  useEffect(() => {
    if (showPicker.isShow) {
      setTimeout(updatePosition, 50); // Ensure picker is rendered before positioning
    } else {
      pickerRef.current = null; // Reset pickerRef when picker is closed
    }

    const handleResize = () => {
      if (pickerRef.current) {
        updatePosition(); // Only call if picker exists
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPicker?.isShow]);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        marginTop: "4px",
      }}
    >
      {/* Color Fill Icon - Click to toggle color picker */}
      <FormatColorFillIcon
        id="tool-icon-text-background-color"
        className="toolbar-icon tool-icon"
        onClick={() => {
          setShowPicker({
            isShow:
              showPicker.type === "backgroundColor" ? !showPicker.isShow : true,
            type: "backgroundColor",
          });
        }}
        style={{
          color: backgroundColor !== "none" ? backgroundColor : "gray",
          fontSize: "30px",
        }}
      />

      {/* Color Picker - Prevent Overflow */}
      {showPicker.type === "backgroundColor" && showPicker.isShow && (
        <div
          ref={pickerRef}
          className="color-picker-container tool-icon"
          style={{
            position: "absolute",
            top: `${position.top}px`,
            left: `${position.left}px`,
            background: "#fff",
            padding: "8px",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
            borderRadius: "5px",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "252px",
            minWidth: "216px",
          }}
        >
          <HexColorPicker
            color={backgroundColor}
            onChange={setBackgroundColor}
          />
          <button
            className="tool-icon"
            onClick={() => setBackgroundColor("none")}
            style={{
              marginTop: "8px",
              padding: "6px 12px",
              cursor: "pointer",
              border: "none",
              background: backgroundColor === "none" ? "#f44336" : "#ddd",
              color: backgroundColor === "none" ? "#fff" : "#000",
              borderRadius: "3px",
              width: "100%",
              textAlign: "center",
              transition: "background 0.3s ease",
            }}
          >
            None
          </button>
        </div>
      )}
    </div>
  );
};

export default BackgroundColorPicker;
